export default {
	token: null,
	editToken: null
};
